import { render, staticRenderFns } from "./ManagerImports.vue?vue&type=template&id=708e6325"
import script from "./ManagerImports.vue?vue&type=script&lang=js"
export * from "./ManagerImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports